import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { translateX } from 'utils';

export const StyledStorySwiper = styled('div')`
  margin-bottom: 32px;

  .story-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    .header-title {
      font-size: 1rem;
      font-weight: 700;
      line-height: 1.5rem;
    }
  }

  .story-items {
    &.skeleton {
      overflow: hidden;

      .story-item {
        max-width: max-content;

        .story-image {
          position: relative;
          overflow: hidden;
          border-radius: 16px;
          border: 1px solid #eeeeee;
          box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24),
            0px 3px 8px -1px rgba(50, 50, 71, 0.05);
          width: 170px;
          height: 302px;
          display: flex;
          background-color: #f5f5f5;

          .story-image-header {
            box-sizing: border-box;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            justify-content: flex-end;
            padding: 8px;
            gap: 8px;
            width: 100%;
            min-height: 48px;
            background: #f5f5f5;
          }
        }

        .story-datetime {
          display: flex;
          justify-content: center;
          min-height: 40px;
        }
      }
    }
  }

  .instagram-story-item-wrapper {
    max-width: max-content;
  }

  .instagram-story-item-wrapper.active-interaction {
    animation: moveLeftAndBack 1s ease-in-out 5s 1;
  }

  @keyframes moveLeftAndBack {
    0% {
      transform: translateX(0);
    }
    50% {
      ${translateX('48px')}
    }
    100% {
      transform: translateX(0);
    }
  }
`;

export const StyledTooltip = styled('span')`
  color: #0f5e62 !important;
  font-weight: 700;
`;

export const StyledSwiper = styled('div')`
  position: relative;

  .show-more-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 270px;
    padding-left: 20px;
  }
`;

export const StyledNavigationButton = styled('span')`
  position: absolute;
  top: 0;
  height: 304px;
  width: 40px;
  z-index: 1;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(108, 135, 155, 0.3);
  cursor: pointer;

  .icon {
    border-radius: 50%;
    padding: 8px;
    transition: all 0.3s ease;
    color: #0c395a;
    background-color: #fcfcfc;
  }

  .custom-loading {
    border-radius: 50%;
    background-color: #fcfcfc;
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;

    & > span {
      color: #0c395a !important;
      display: block;
      width: 20px !important;
      height: 20px !important;
    }
  }

  &:hover {
    background: rgba(108, 135, 155, 0.5);
  }
`;

export const StyledPrevButton = styled(StyledNavigationButton)(
  ({ hide, styles }) => css`
    right: 0;
    display: ${hide ? 'none' : 'flex'};

    ${styles}
  `
);

export const StyledNextButton = styled(StyledNavigationButton)(
  ({ hide, styles }) =>
    css`
      left: 0;
      display: ${hide ? 'none' : 'flex'};

      ${styles}
    `
);
